import type { PropsWithChildren } from "react";
import React from "react";

import { VehicleType } from "@busbud/int-schemas/lib/vehicles";

import type { DepartureStop as DepartureStopType } from "../types";

import { GenericStop } from "../generic-stop";
import { VehicleIcon } from "../vehicle-icon";

interface Props {
  hide_location?: boolean;
  stop: DepartureStopType;
  stop_details_link?: string;
}

export const DepartureStop: React.FC<PropsWithChildren<Props>> = ({
  hide_location,
  stop,
  stop_details_link
}) => {
  return (
    <GenericStop
      operator={stop.operator}
      stop_service_name={stop.service_name}
      stop_service_number={stop.service_number}
      time={stop.departure_time}
      name={stop.departure_name}
      city_name={stop.departure_city_name}
      lat={stop.departure_lat}
      lon={stop.departure_lon}
      vehicle_type={stop.departure_vehicle}
      icon={
        <VehicleIcon
          type={stop.departure_vehicle ?? VehicleType.Bus}
          color="accent.primary.400"
          size="MD"
        />
      }
      hide_location={hide_location}
      duration={stop.duration}
      stop_details_link={stop_details_link}
      stop_location_type={stop.stop_location_type}
    />
  );
};
